<!-- Brand Name -->
<div class="row pt-2 pb-2 bg-white">
    <div class="col-5">
        <span class="text-muted fw-bold">Manufacturer</span>

        <select class="form-select text-muted mt-2" 
          placeholder="Select"
          [(ngModel)]="selectedManufacturer"
          [disabled]="manufacturersLoading === true"
          (change)="onManufacturerChange($event)">
          <option *ngFor="let manufacturer of manufacturers" [value]="manufacturer.mfg_id">{{ manufacturer.mfg_name }}</option>
        </select>
    </div>
    <div class="col-6">
      <span class="text-muted fw-bold">Enter New Brand Name</span>

      <input type="text" class="form-control mt-2" id="brand_name" maxlength="50" placeholder="E.g. Aquafina" [(ngModel)]="brandName">
    </div>
    <div class="col-1 mt-4">
        <button class="btn btn-secondary float-end mt-2" [disabled]="currentAction" (click)="manageBrand()">Add</button>
    </div>
  </div>

<!-- Display brands -->
<div class="row pt-2 pb-2 m-1 bg-white">
    <!-- Loading -->
    <div class="col-12 text-center" *ngIf="currentAction == 'getBrands'">
        <div class="spinner-border text-info mt-4" role="status"></div>
    </div>

    <!-- Brand list -->
    <div class="col-12 border" *ngIf="currentAction == ''">
        <!-- Header -->
        <div class="row grid-row border-bottom mt-2">
            <div class="col-12 grid-title">Brands</div>
        </div>

        <div class="row grid-row border-bottom border-light mt-2" *ngFor="let brand of brands">
            <div class="col-12 grid-item">{{ brand.brand_name }}</div>
        </div>
    </div>
</div>